import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type Kind = 'new' | 'saved' | 'recent';

export interface State {
  kind: Kind;
  id: string; // it will be saved/recent search id
  draftId: string | null; // it is recent search id, it will be used when you are applying filters on search/new page and any recent will be created
}

export interface Actions {
  setKind: (kind: Kind) => void;
  setId: (id: string) => void;
}

/**
 * Store to maintain search kind whether it is saved/recent OR new.
 */
const useKind = create<State & Actions>()(
  devtools(
    immer((set) => ({
      kind: 'new',
      id: 'new',
      draftId: null,
      setKind: (kind) =>
        set({ kind }, false, {
          type: 'SET_SEARCH_KIND',
        }),
      setId: (id) =>
        set({ id }, false, {
          type: 'SET_SEARCH_ID',
        }),
    })),
    {
      store: 'SearchKind',
    },
  ),
);

export { useKind };
